import {isNotNil, sortBy} from 'ramda';

import {getSafely} from 'shared/web';

import {RelativeFilterResponseBody} from '../../../../../types/api/api';

export function sortPresetsForDropdown(
  presets: RelativeFilterResponseBody[]
): RelativeFilterResponseBody[] {
  const ordered = sortBy((preset) => preset.position, presets);
  const defaultIndex = ordered.findIndex((preset) => preset.default);

  if (defaultIndex <= 0) {
    return ordered;
  }

  const defaultPreset = getSafely(ordered, defaultIndex);
  return isNotNil(defaultPreset)
    ? [defaultPreset, ...ordered.slice(0, defaultIndex), ...ordered.slice(defaultIndex + 1)]
    : ordered;
}
